import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Contact() {
	return (
		<main className="min-h-screen bg-white">
			<Helmet>
				<title>お問い合わせ | しろぬきや</title>
			</Helmet>
			<header className="border-b border-gray-100 bg-white sticky top-0 z-10">
				<div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-2">
					<Link
						to="/"
						className="flex items-center gap-2 hover:opacity-80 transition"
					>
						<span className="text-2xl">✂️</span>
						<span className="font-bold text-lg text-gray-900">しろぬきや</span>
					</Link>
				</div>
			</header>

			<div className="max-w-3xl mx-auto px-4 py-12">
				<h1 className="text-3xl font-bold text-gray-900 mb-2">お問い合わせ</h1>
				<p className="text-sm text-gray-500 mb-10">Contact</p>

				<div className="text-gray-700 leading-relaxed space-y-6">
					<p>
						お問い合わせは以下のフォームよりお願いいたします。
						内容を確認の上、順次ご返答いたします。
					</p>

					<div className="text-center py-8">
						<a
							href="https://forms.gle/gWQ1ugL23sEZ1iVb9"
							target="_blank"
							rel="noopener noreferrer"
							className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-medium px-8 py-4 rounded-lg transition"
						>
							お問い合わせフォームを開く
						</a>
					</div>

					<p className="text-sm text-gray-500">
						※
						サービスに関するご質問・ご要望・不具合報告などお気軽にお送りください。
					</p>
				</div>
			</div>

			<footer className="text-center py-8 text-gray-400 text-sm border-t border-gray-100">
				<p>© 2026 しろぬきや</p>
				<div className="mt-2 flex justify-center gap-4">
					<Link to="/terms" className="hover:text-gray-600 transition">
						利用規約
					</Link>
					<Link to="/privacy" className="hover:text-gray-600 transition">
						プライバシーポリシー
					</Link>
					<Link to="/contact" className="hover:text-gray-600 transition">
						お問い合わせ
					</Link>
				</div>
			</footer>
		</main>
	);
}
